// removed by extract-text-webpack-plugin
module.exports = {"submit-btn":"_3plG","hide-btn-text":"_2YAu","spinner":"_1mnL","bounce":"_31AK","bounce4":"_O9ha","bounce5":"_HYAO","bounce1":"_MI2_","bounce2":"_1j-H","bounce3":"_3lhA","rupee-sign":"_3E3t","btn-primary":"_1hX2"};


//////////////////
// WEBPACK FOOTER
// ./form/components/button/style.css
// module id = gbHb
// module chunks = 4